export default {
  props: ['errors', 'value', 'label', 'placeholder', 'addon', 'textarea', 'type', 'mode'],
  data: function () {
    return {}
  },
  methods: {
    updateValue(val) {
      this.$emit('input', val)
    },

    showPassword() {
      this.$emit('showPassword')
    },

    hidePassword() {
      this.$emit('hidePassword')
    },
  },
}
